<script lang="ts">
  import css from "../../../css/comments.pcss.json";
  import { numString } from "../../common/helpers.js";
  import CommentLines from "./CommentLines.svelte";
  import SVG from "../SVG_svelte.svelte";
  import type { CommentModel } from "../comments/CommentTypes";
  import type { Writable } from "svelte/store";
  import { getContext } from "svelte";
  import type { CommentsStateType } from "./MaterialComments.svelte";

  let state: Writable<CommentsStateType> = getContext('comments')

  export let comment: CommentModel
  export let showSeparator: boolean = false
  export let canHideChildren: boolean = false

  const containerClasses = []
  const levels = comment.levels ?? []
  const classes = [css['comment']]

  if (comment.highlight === true || comment.isNew) {
    classes.push(css['comment--highlight'])
  }

  if (levels.length > 0) {
    levels[levels.length - 1].hasChildren = comment.childrenIds.length > 0
  }

  if (showSeparator && (!comment.level || comment.level == 0)) {
    containerClasses.push(css['comment--separator'])
  }

  if (comment.level > 0) {
    comment.level = comment.level > 6 ? 6 : comment.level
    containerClasses.push(css[`comment--level-${comment.level}`])
  }

  canHideChildren = canHideChildren && (comment.level === 2 && comment.totalChildLength > 1)

  let toggleChildrenLevels = [...(comment.levels ?? []), {
    id: -1,
    parentId: comment.comment_id,
    hasLaterSiblings: comment.childrenShown,
    hasChildren: false,
    hideCurrent: comment.childrenShown,
    shortHeight: true
  }];

  let doToggleChildren = () => {
    $state.toggleChildren(comment.comment_id)
  }

  const formLevel = comment.level + 1 > 6 ? 6 : comment.level + 1
  const formClass = css[`comment--level-${formLevel}`]
</script>

<div class={containerClasses.join(' ')} style='position: relative' id={`comment_${comment.comment_id}`}>
    {#if comment.level > 0}
        <CommentLines levels={levels}/>
    {/if}
    <article class={classes.join(' ')}>
        <p class={css['deleted-text']}>
            {#if comment.deleted_by_moder}
                {comment.comment_delete_reason || 'Комментарий удалён модератором'}
            {:else}
                Пользователь удалил свой комментарий
            {/if}
        </p>
    </article>
    {#if canHideChildren}
        <div class={formClass}>
            <CommentLines levels={toggleChildrenLevels}/>
            <button class={css['comment__hide-children']} on:click={doToggleChildren}>
                Ещё {comment.totalChildLength} {numString(comment.totalChildLength, ['комментарий', 'комментария', 'комментариев'])}
                <SVG i={comment.childrenShown ? 'sg/chevron-up' : 'sg/chevron-down'}/>
            </button>
        </div>
    {/if}
</div>
